import { getShadow } from '../mixins';
/** @type {typeof getShadow} */

export var shadow = getShadow;